export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7322.5afed723.jpg";